import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '需求说明',
    type: 'BJ_REQ',
}
